import { Component, Input, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';

@Component( {
    selector: 'app-modal',
    templateUrl: 'modal.component.html',
    styleUrls: ['modal.component.css']
})

export class ModalComponent implements OnInit
{
    @Input() buttons: string[];
    @Input() message: string;
    @Input() inputRequired: boolean;
    @Input() inputLabel: string;
    @Input() width = 500;
    @Input() height = 300;
    @Input() title: string;

    @ViewChild( 'modalBody' ) body: ElementRef;

    public inputText = '';
    public visible = false;
    private visibleAnimate = false;
    private onClose: Function;

    public show(onClose?: Function): void
    {
        this.onClose = onClose;
        this.visible = true;
        setTimeout(() => this.visibleAnimate = true );
    }

    public hide( button: string ): void
    {
        this.reset();
        setTimeout(() => this.visible = false, 150 );
        if (this.onClose) {
            this.onClose(button);
        }
    }

    private reset()
    {
        this.visibleAnimate = false;
        this.buttons = ['Ok'];
        this.inputRequired = false;
        this.inputLabel = 'Label:';
        this.title = 'Tartan';
        this.message = 'You still need to set the modal message body.';
    }

    ngOnInit()
    {
        this.reset();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Modal/modal.component.ts